import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MatrixRain from "../components/MatrixRain";
import { Footer } from "../components/Sections";
import { ASSETS } from "../mock";
import { usePageTracking, track } from "../analytics";
import { whopTrack } from "../pixels";

const VIDALYTICS_ACCOUNT = "05PByEt0";
const VIDEO_ID = "jp_bjnJrqdE3jxrC";

const VslEmbed = () => {
  const embedId = `vidalytics_embed_${VIDEO_ID}`;
  useEffect(() => {
    if (window.__vslInit) return;
    window.__vslInit = true;
    const base = `https://fast.vidalytics.com/embeds/${VIDALYTICS_ACCOUNT}/${VIDEO_ID}/`;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.text = `(function (v, i, d, a, l, y, t, c, s) {
      y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
      if (!vsl){vsl=function(u,cb){
        if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
        if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
        i.getElementsByTagName("head")[0].appendChild(s);
      };}
      vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
    })(window, document, 'Vidalytics', '${embedId}', '${base}');`;
    document.body.appendChild(script);
  }, [embedId]);

  return (
    <div
      id={embedId}
      style={{ width: "100%", position: "relative", paddingTop: "56.25%" }}
    />
  );
};

const VideoPage = () => {
  usePageTracking("video");
  const navigate = useNavigate();
  const firedView = useRef(false);

  useEffect(() => {
    if (firedView.current) return;
    firedView.current = true;
    track("video_page_view", { funnel: "vsl", step: 1 });
    whopTrack("video_page_view", { funnel: "vsl", step: 1 });
  }, []);

  const goToBooking = () => {
    track("book_call_click", { funnel: "vsl", step: 2, source: "video_page" });
    whopTrack("book_call_click", { funnel: "vsl", step: 2 });
    navigate("/calendar-booking");
  };

  return (
    <div className="min-h-screen bg-black">
      <header className="relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-[420px]">
          <MatrixRain />
          <div className="matrix-fade" />
        </div>

        <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-5 pt-10">
          <img
            src={ASSETS.logoEmblem}
            alt="The Matrix Unlocked"
            className="h-16 w-auto sm:h-20"
          />
          <h1 className="mt-5 text-balance text-center text-3xl font-bold leading-[1.1] tracking-tight text-white sm:text-5xl md:text-[56px]">
            Watch The <span className="text-[#16E36F]">Free Training</span>
          </h1>
          <p className="mt-4 max-w-2xl text-balance text-center text-lg font-medium leading-snug text-neutral-300 sm:text-xl md:text-2xl">
            It Will Change Your{" "}
            <span className="font-semibold text-[#16E36F]">Perspective</span> On
            The <span className="font-semibold text-[#16E36F]">Markets</span>{" "}
            <span className="font-semibold text-[#16E36F]">For Good.</span>
          </p>
        </div>

        <div className="relative z-10 mx-auto mt-8 w-full max-w-4xl px-4 pb-16 sm:px-5">
          <div
            className="overflow-hidden rounded-2xl border border-[#16E36F]/25 bg-[#050806] shadow-[0_20px_80px_rgba(0,0,0,0.6)]"
            data-testid="vsl-video-wrap"
          >
            <VslEmbed />
          </div>

          <div className="mt-8 flex flex-col items-center">
            <button
              type="button"
              onClick={goToBooking}
              data-testid="video-book-call-btn"
              className="inline-flex w-full max-w-xs items-center justify-center rounded-xl bg-[#16E36F] px-8 py-4 text-base font-bold text-black shadow-[0_8px_30px_rgba(22,227,111,0.35)] transition-transform duration-200 hover:scale-[1.03] sm:w-auto sm:max-w-none sm:px-10 sm:text-lg"
            >
              Book A Call
            </button>
            <p className="mt-3 text-center text-sm text-neutral-500">
              Speak 1-on-1 with my team to learn more
            </p>
          </div>
        </div>
      </header>

      <Footer />
    </div>
  );
};

export default VideoPage;
